<template>
  <div v-show="showModal">
    <div class="modal">
      <div class="modalHead">
        <p class="title"><slot name="info"></slot></p>
      </div>
      <div class="modalCont">
        <div class="inner">
          <slot name="content"></slot>
        </div>
      </div>
      <div>
        <slot name="button"></slot>
      </div>
    </div>
    <div class="dim">
      <slot name="dimarea"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: true,
    };
  },
};
</script>
